export default [
    {
        code: 'y',
        name: 'Yes',
    },
    {
        code: 'n',
        name: 'No',
    },
];